
    <ng-container *ngIf="fileDataReady" [ngSwitch]="file.type">
      <file-view-image *ngSwitchCase="'image'" [file]="file"></file-view-image>
      <file-view-pdf *ngSwitchCase="'pdf'" [file]="file"></file-view-pdf>
      <file-view-video-native *ngSwitchCase="'nativevideo'" [file]="file"></file-view-video-native>
      <file-view-3d *ngSwitchCase="'threeds'" [file]="file"></file-view-3d>
      <file-view-unknown *ngSwitchDefault [file]="file"></file-view-unknown>
    </ng-container>
  


// WEBPACK FOOTER //
// ./src/app/files.view.component.ts.FileViewerComponent.html